import React, { useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Save } from "lucide-react";

/** Identité de l'éditeur : valeurs injectées dans les documents via {{placeholders}}. */
export function LegalEditeurForm({ fields, value, onSaved }) {
  const [form, setForm] = useState(value || {});
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/legal/editeur", form); toast.success("Identité de l'éditeur enregistrée"); onSaved?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white border border-[#DEE2E6] p-6 max-w-4xl" data-testid="legal-editeur-form">
      <div className="text-xs uppercase tracking-[0.25em] font-semibold text-[#868E96] mb-1">Éditeur de la plateforme</div>
      <p className="text-xs text-[#495057] mb-5">Ces informations remplacent automatiquement les balises <code className="font-mono bg-[#F1F3F5] px-1">{"{{raison_sociale}}"}</code>, <code className="font-mono bg-[#F1F3F5] px-1">{"{{adresse}}"}</code>… dans les quatre documents.</p>
      <div className="grid md:grid-cols-2 gap-4">
        {(fields || []).map((f) => (
          <div key={f.key} className={f.key === "hebergeur" || f.key === "adresse" ? "md:col-span-2" : ""}>
            <Label className="text-[10px] uppercase tracking-[0.2em] font-semibold">{f.label} <span className="font-mono normal-case tracking-normal text-[#868E96]">{`{{${f.key}}}`}</span></Label>
            <Input value={form[f.key] ?? ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`legal-editeur-${f.key}`} className="h-10 mt-1" />
          </div>
        ))}
      </div>
      <Button onClick={save} disabled={busy} data-testid="legal-editeur-save" className="mt-5 h-10 bg-[#0A0A0A] text-white"><Save className="h-4 w-4 mr-2" />{busy ? "Enregistrement…" : "Enregistrer"}</Button>
    </div>
  );
}
